module.exports = __webpack_public_path__ + "static/media/dizzy.f0f1b74f.svg";